import React from 'react';
import { IconType } from 'react-icons';
import './KPICard.css';

interface KPICardProps {
  icon: IconType;
  headline: string;
  value: string | number;
  centered?: boolean;
}

const KPICard: React.FC<KPICardProps> = ({ icon: Icon, headline, value, centered = false }) => {
  const IconComponent = Icon as React.ComponentType<{ className?: string }>;
  
  return (
    <div className={`kpi-card ${centered ? 'kpi-card-centered' : ''}`}>
      <div className="kpi-header">
        <IconComponent className="kpi-icon" />
        <span className="kpi-headline">{headline}</span>
      </div>
      <div className="kpi-value">
        {value}
      </div>
    </div>
  );
};

export default KPICard;
